import { pushTo } from '@app/core/routing';
import { auditReports, auditReportsApiClient } from '@mi-front/api-clients';
import { ReportExportInfo } from '../../gip-report/view/components/export-info/ReportExportInfo';
import { GipReportActions } from '../../gip-report/view/components/GipReportActions';
import { GipDetails } from '../../gip-report/view/components/GipReportViewShared';

interface Props {
  readonly report: auditReports.GipAltReportDto;
}

export function GipAltReportDetail({ report }: Props) {
  return (
    <GipDetails
      report={report}
      actions={
        <GipReportActions
          report={report}
          exportFn={(params) =>
            auditReportsApiClient.generateUrl(
              auditReports.getExportGipAltReportUrl(report.id).url,
              params,
            )
          }
          onClone={() => {
            pushTo(`/audit/global-reports/gip-alternative-report?report=${report.id}`);
          }}
        />
      }
      exportInfo={<ReportExportInfo report={report} />}
    />
  );
}
